import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b1710d0a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1710d0a')) {
      api.createRecord('b1710d0a', component.options)
    } else {
      api.reload('b1710d0a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b1710d0a&", function () {
      api.rerender('b1710d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ozk4036Zrazi/JS/comp/FavElement.vue"
export default component.exports